<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        inline
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item label="授权用户">
          <el-input v-model.trim="userName" placeholder="请输入授权用户" style="width: 202px;" />
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="operateType" placeholder="请选择操作类型">
            <el-option
              v-for="item in operateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="date">
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.startTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getData()"
      >查询</el-button>
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="userName"
          label="授权用户"
          minWidth="120"
          align="center"
        />
        <el-table-column
          prop="targetUserName"
          label="用户"
          minWidth="160"
          align="center"
        />
        <el-table-column
          property="operateTypeName"
          label="操作类型"
          minWidth="150"
          align="center"
        />
        <el-table-column
          property="createTime"
          label="授权时间"
          minWidth="150"
          align="center"
        />
        <el-table-column
          property="remark"
          label="备注"
          minWidth="150"
          align="center"
        />
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getData"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
import { mapState } from 'vuex';

export default {
  components: {
    ManageBox,
  },
  data() {
    return {
      userName: '',
      operateType: '',
      loading: false,
      operateOptions:[
        { value:'', label:'全部' },
        { value:1, label:'新增' },
        { value:2, label:'修改' },
        { value:3, label:'删除' },
      ],
      form: {
        startTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
    this.getData();
  },

  methods: {
    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    //获取数据
    async getData() {
      let params = {
        startTime: day(this.form.startTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        pageSize:this.pageSize,
        pageNumber:this.currentPage,
        userName:this.userName,
        operateType:this.operateType,
      };

      if (this.form.startTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      if (this.searchValue === null) {
        this.$msg({
          showClose: true,
          message: "请选择/输入终端ID",
          type: "error"
        });
        return;
      }
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total } = await this.$API.pageUserRoleLog(params);
        this.total = total;
        this.tableData = data?.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        })) ?? [];
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .date {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
</style>
